// Componente Button - Botón reutilizable
// Basado en los estilos del mockup

import './Button.css'

/**
 * Componente Button
 * Botón reutilizable con diferentes variantes y tamaños
 * @param {Object} props - Propiedades del componente
 * @param {string} props.variant - Variante del botón: 'primary', 'secondary', 'accent', 'outline'
 * @param {string} props.size - Tamaño del botón: 'small', 'medium', 'large'
 * @param {React.ReactNode} props.children - Contenido del botón
 * @param {Function} props.onClick - Función a ejecutar al hacer clic
 * @param {boolean} props.disabled - Si el botón está deshabilitado
 * @param {string} props.type - Tipo de botón: 'button', 'submit', 'reset'
 * @param {string} props.className - Clases CSS adicionales
 */
function Button({
  variant = 'primary',
  size = 'medium',
  children,
  onClick,
  disabled = false,
  type = 'button',
  className = ''
}) {
  // Construir clases CSS basadas en las props
  const buttonClasses = `btn btn-${variant} btn-${size} ${className}`.trim()

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default Button

